import Axios from 'axios';
import { API } from '../api';

const upload = (url, data) => Axios.post(url, data, { headers: { 'Accept': 'application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8', 'Content-Type': 'multipart/form-data' } })
    .then(response => API.isSuccess(response.data) ? response.data.data.path : null);

export const ApiImageService = {
    upload
};